var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('EpButton',{attrs:{"kind":'primary',"element":'a',"link":_vm.redirect_uri,"label":true,"labelText":'Connect to Strava',"icon":true,"iconSource":'sign-in',"iconAlignRight":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }